import { getSdk } from '@graphql/generated/sdk';
import {
  DocumentNode,
  Kind,
  OperationDefinitionNode,
  OperationTypeNode,
  print,
} from 'graphql';

import request from './request';

const extractOperation = (
  document: DocumentNode
): OperationDefinitionNode | undefined => {
  const operationDefinitions = document.definitions.filter(
    definition => definition.kind === Kind.OPERATION_DEFINITION
  );

  return operationDefinitions[0] as OperationDefinitionNode | undefined;
};

const getAPI = () => {
  const url = process.env.NEXT_PUBLIC_GRAPHQL_URI!;

  const sdk = getSdk(
    async <R, V>(
      doc: DocumentNode,
      vars: V | undefined,
      options?: {
        revalidate?: string[];
        tags?: string[];
        revalidatePath?: string;
      }
    ): Promise<R> => {
      const operation = extractOperation(doc);
      const operationName = operation?.name?.value;
      const tags = [operationName ?? '', ...(options?.tags ?? [])];
      const isQuery = operation?.operation === OperationTypeNode.QUERY;

      const settings: RequestInit & { url: string } = {
        body: JSON.stringify({
          operationName,
          query: print(doc),
          variables: vars,
        }),
        next: {
          revalidate: isQuery ? 180 : 1,
          tags: tags,
        },
        url,
      };

      const data = (await request(
        settings,
        options?.revalidate,
        options?.revalidatePath
      )) as {
        errors?: { message: string }[];
        data?: unknown;
      };

      if (data.errors) {
        throw new Error(data.errors[0]?.message);
      }

      return data as R;
    }
  );

  return sdk;
};

export default getAPI;
